import app from 'flarum/forum/app'
import Button from 'flarum/common/components/Button'
import CommentPost from './CommentPost'
import DiscussionControls from 'flarum/forum/utils/DiscussionControls'
import ShareModal from './fof-social/ShareModal'
import SubscriptionMenu from './subsciptions/SubscriptionMenu'
import icon from 'flarum/common/helpers/icon';
import tagsLabel from 'flarum/tags/helpers/tagsLabel'
import { togglePostLiked } from '../extend/comment-post'

export default class DiscussionPost extends CommentPost {
    oninit(vnode) {
        super.oninit(vnode);

        this.likesCount = this.attrs.post.likesCount();
        this.networks = app.forum.attribute('fof-share-social.networks');
        this.isAuthor = this.attrs.post.user() === app.session.user;
        this.isModerator = app.session.user?.groups().some(group => group.id() === '4');
    }

    view() {
        const { post, discussion, reRouteLoggedOutUser } = this.attrs;
        const likes = post.likes();
        let isLiked = app.session.user && likes && likes.some((user) => user === app.session.user);
        const tagsLength = discussion.tags()?.length;

        return (
            <div className='DiscussionPost'
                data-index="0"
                data-number="1"
                data-id={post.id()}
                data-time={post.createdAt()}
                data-type={post.contentType()}
                key={`post${post.id()}`}
                onclick={reRouteLoggedOutUser}
            >
                <div className='DiscussionPost-header'>
                    <div className="header-top">
                        <div>
                            <p className='header-tagsList'>
                                {discussion.tags()[0] && tagsLabel([discussion.tags()[0]])} 
                                {tagsLength > 1 && <span className='tagsCount'>{`+${+tagsLength - 1}`}</span>}
                            </p>
                            <h3 className='header-title'>{discussion.title()}</h3>
                        </div>
                        <div className='header-buttonList'>
                            <Button 
                                className='Button' 
                                icon={`${isLiked ? 'fas' : 'far'} fa-thumbs-up`} 
                                aria-label="Like"
                                alt={`${isLiked ? 'Liked' : 'Like'}`}
                                onclick={async () => {this.toggleLikesCount(isLiked), await togglePostLiked(post, isLiked)}} 
                            />
                            {(this.isAuthor || this.isModerator) && 
                                <Button 
                                    className='Button share-btn' 
                                    icon='far fa-reply fa-flip-horizontal' 
                                    aria-label="Share"
                                    alt="Share"
                                    onclick={() => this.share()} 
                                />
                            }
                            <SubscriptionMenu 
                                discussion={discussion} 
                                onlyDropDown={true} 
                                onSubscriptionChange={this.handleSubscriptionChange}
                            />
                            <Button 
                                className='Button' 
                                icon='far fa-comment' 
                                aria-label="Comment"
                                alt="Comment"
                                onclick={this.reply.bind(this)}
                            >
                                Comment
                            </Button>
                        </div>
                    </div>

                    <div className="header-bottom">
                        <p className='header-likes'>{icon('far fa-thumbs-up')} 
                            {this.likesCount} 
                            {this.likesCount === 1 ? ' like' : ' likes'}
                        </p>
                        <div className='header-count'>
                            <p>{icon('far fa-eye')} {discussion.viewCount()} views</p>
                            <p>{icon('far fa-comment')} {discussion.commentCount()} comments</p>
                        </div>
                    </div>
                </div>

                <div className='PostStream-item discussion'>
                    <CommentPost 
                        post={post} 
                        isDiscussionPost={true} 
                        togglePostLiked={async () => {
                            this.toggleLikesCount(isLiked), await togglePostLiked(post, isLiked)
                        }}
                        setCardOpen={this.attrs.setCardOpen}
                        setCardClosed={this.attrs.setCardClosed}
                        replyToPost={this.reply.bind(this)}
                    />
                </div>
           </div>
        )
    }

    share() {
        app.modal.show(ShareModal, {
            networks: this.networks,
            discussion: this.attrs.discussion,
          })
    }

    reply() {
        DiscussionControls.replyAction.call(this.attrs.discussion, true).catch(() => {});
    }

    toggleLikesCount(isLiked) {
        this.likesCount = isLiked ? this.likesCount - 1 : this.likesCount + 1;
    }

    handleSubscriptionChange = (newSubscription) => {
        this.attrs.subscription = newSubscription;
        this.attrs.onSubscriptionUpdate && this.attrs.onSubscriptionUpdate();
    }
}
